import React from "react";
import { Box, RadioGroup } from "@mui/material";
import { DotLegalHeader, DotLegalRadioButton } from "@dotlegal/dotlegal-ui-components";
import { getEnumValues } from "@common/enumOperations.ts";
import { setFirstLetterToLowerCase } from "@common/stringOperations.ts";
import { useTranslation } from "@localization/useTranslation.ts";
import { IncidentLogNotificationAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

export interface IncidentLogNotificationAnswerFieldProps {
    label: string;
    answer?: IncidentLogNotificationAnswer | null;
    onChange: (answer: IncidentLogNotificationAnswer) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogNotificationAnswerField(props: IncidentLogNotificationAnswerFieldProps) {
    const { translateString } = useTranslation();

    return (
        // Same spacing as IncidentLogDateTimeField: the DotLegal field below brings its own top margin.
        <Box sx={{ mt: 2 }}>
            <DotLegalHeader marginBottom={0} headerStyle={"small"}>
                {props.label}
            </DotLegalHeader>
            <RadioGroup
                row
                value={props.answer ?? null}
                onChange={(e) => props.onChange(Number((e.target as HTMLInputElement).value) as IncidentLogNotificationAnswer)}
            >
                {getEnumValues(IncidentLogNotificationAnswer).map((answer) => (
                    <DotLegalRadioButton
                        key={answer}
                        value={answer}
                        labelPlacement="end"
                        label={translateString(setFirstLetterToLowerCase(IncidentLogNotificationAnswer[answer]))}
                        disabled={props.disabled}
                    />
                ))}
            </RadioGroup>
            {props.errorText && <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main })}>{props.errorText}</Box>}
        </Box>
    );
}

export default IncidentLogNotificationAnswerField;
